import React from 'react'
import PropTypes from 'prop-types'

import {
  Container,
  Number,
  Title,
} from './styles'

const Card = ({ number, title }) => {
  return (
    <Container number={number}>
      <Number
        weight={'medium'}
        size={['16/20', '16/20', '14/20']}
        dangerouslySetInnerHTML={{ __html: number }}
      />

      <Title
        size={['22/30', '22/30', '16/25']}
        dangerouslySetInnerHTML={{ __html: title }}
      />
    </Container>
  )
}

Card.propTypes = {
  number: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
}

export default Card
